import styled from 'styled-components'

import { helpers } from 'styles'

import { Container } from './Container'

export const Chevron = styled.div`
	opacity: 0;
	height: 16px;
	color: ${helpers.color.text};
	transition: opacity 0.2s;

	${Container}:hover & {
		opacity: 1;
	}
`
